window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

window.Sparkle.Utilities.DetectCssEvent = {
  transition: {
    end: function detectEnd() {
      var t;
      var el = document.createElement("fakeelement");
      var transitions = {
        transition: "transitionend",
        OTransition: "oTransitionEnd",
        MozTransition: "transitionend",
        WebkitTransition: "webkitTransitionEnd",
      };

      for (t in transitions) {
        if (el.style[t] !== undefined) {
          return transitions[t];
        }
      }
    },
  },
};
